import React from "react";
import banner from "../assets/banner2.jpg";

export default function NdomanoMotors() {
  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-md-6 order-md-1 text-center">
            <img src={banner} alt="Ndomano Motors" className="img-fluid rounded" style={{maxHeight: '320px', objectFit: 'cover'}} />
          </div>
          <div className="col-md-6 order-md-2">
            <h2 className="main-section-title">Ndomano Motors (T) LTD</h2>
            <p className="text-muted">
              Ndomano Motors is your trusted partner in automotive care. We provide comprehensive repair services, genuine spare parts, and preventive maintenance solutions to keep vehicles safe and reliable. Our technicians are trained to international standards and equipped to service a wide range of makes and models.
            </p>
            <p className="text-muted">
              With a focus on customer satisfaction and operational efficiency, Ndomano Motors combines transparent pricing, warranty-backed parts, and digital service records to simplify vehicle ownership for individuals and commercial fleets.
            </p>
            <div className="my-3">
              <a className="btn btn-primary" href="https://ndomanomotors.com" target="_blank" rel="noreferrer">Visit Ndomano Motors</a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
